namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class DetailAdmSystemovyCertifikat extends GContentBase {
        private dataListDescription: Gordic.General.ApplicationInterface.GDataListDescription;
        private data: Gordic.AdmIsl.Interface.GAdmSystemovyCertifikatListDto;
        private detailObj: DetailAdmSystemovyCertifikatObj & GContent;

        // hodnota parametru adx_checkiconad 
        private currentFilter: any;
        private gridRc: Gordic.Components.GridRC<any>;
        private createPreviousAndNextAction: boolean;

        onDetailBuilderInit(builder: Gordic.Gin.DetailBuilder.GDetailBuilder) {
            this.detailObj = $.extend(this, new DetailAdmSystemovyCertifikatObj());
            this.detailObj.createBase({
                contentName: "detailAdmSystemovyCertifikat",
                contentCaption: "jres:33000583", //RC 33000583 : Systémový certifikát
                newRecord: false,
                data: { data: this.data },
                dataListDescription: this.dataListDescription,
                addPlatnost: true,
                currentFilter: this.currentFilter,
                gridRc: this.gridRc,
                createPreviousAndNextAction: this.createPreviousAndNextAction,
            });
            this.detailObj.dataListDescription = this.dataListDescription;
            this.detailObj.gridRc = this.gridRc;
            builder.withComponent<this>("DetailAdmSystemovyCertifikat", {
                statusBar: this.detailObj.createStatusBar(),
                menuBar: this.detailObj.createMenuBar(),
                headerForm: this.detailObj.createFormComplet(),
                commandBar: this.detailObj.createCommandBar()
            })
        }

        onContentReady() {
            this.detailObj.finishBuilder()
        }

        closing() {
            return this.detailObj.closeAction();
        }
    }


    export class DetailAdmSystemovyCertifikatObj extends GAdmDetailBase<Gordic.AdmIsl.Interface.GAdmSystemovyCertifikatListDto> {
        dataListDescription: Gordic.General.ApplicationInterface.GDataListDescription;
        filterObj: any
        gridRc: Gordic.Components.GridRC<any>

        create() {

        }

        textPopis(): string | undefined | null {
            return this.data["stat_txt"]
        }

        setSxsDetail(): string {
            return "{0}#{1}#{2}#{3}#".format((this.data.ixs_cer) ? this.data.ixs_cer.toString() : "",
                (this.data.ixs) ? this.data.ixs.toString() : "",
                (this.data.lic) ? this.data.lic.toString() : "",
                (this.data.por_zast) ? this.data.por_zast.toString() : ""
            );
        }

        saveData(data: Gordic.AdmIsl.Interface.GAdmSystemovyCertifikatSaveDto, close: boolean) {

        }

        reloadData(filterObj: any, dataObj: any) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailAdmSystemovyCertifikat", filterObj], dataObj);
        }

        updateGrid(filter: any, grid: any): any {
            return this.cnt.isl.AdmSystemovyCertifikat.list({
                filters: filter
            }).getView().promise()
        }

        createTitle(): string {
            if (this.options.newRecord == true)
                return "jres:32000121";
            return "{0} - {1}".format(this.options.contentCaption, (this.data.jmeno_cer) ? this.data.jmeno_cer : "");
        }

        createMenuBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                { action: this.cnt.actions.actDownload, favorite: true },
                { action: this.cnt.actions.actChangeAktivitaCertifikat, favorite: true },
                { action: this.cnt.actions.actPreviousSpecial, favorite: true, align: "opposite" },
                { action: this.cnt.actions.actNextSpecial, favorite: true, align: "opposite" }
            ]
        }

        createCommandBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                "actClose*"
            ]
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return {
                actPreviousSpecial: {
                    caption: "jres:33000002", //RC 33000002 : Předchozí
                    captionVisible: "never",
                    enabled: (this.options.gridRc?.current()) ? this.options.gridRc?.current().prevRow != null : false,
                    icon: "gi-arrow-down gi-rot180",
                    run: (ev, ctx) => {
                        this.nextAndPreviousActionSpecial(false)
                    }
                },
                actNextSpecial: {
                    caption: "jres:33000001",  //RC 33000001 : Další­
                    captionVisible: "never",
                    enabled: (this.options.gridRc?.current()) ? this.options.gridRc?.current().nextRow != null : false,
                    icon: "gi-arrow-down",
                    run: (ev, ctx) => {
                        this.nextAndPreviousActionSpecial(true)
                    }
                },
                actDownload: {
                    caption: "jres:33000576", //RC 33000576 : Stáhnout certifikát
                    icon: "gi-download",
                    run: (ev, ctx) => {
                        this.downloadCertificate()
                    }
                },
                actChangeAktivitaCertifikat: {
                    caption: "jres:33000578", //RC 33000578 : Změnit aktiviru certifikátu
                    icon: "gi-pencil",
                    enabled: this.dataListDescription.data_right?.Write == true,
                    run: (ev, ctx) => {
                        this.changeAktivitaCer();
                    }
                },
                actChangeAktivitaCertifikatSave: {
                    caption: "jres:32131041",
                    icon: "gi-save",
                    enabled: this.dataListDescription.data_right?.Write == true,
                    run: (ev, ctx) => {
                        this.saveAktivitaCer(ev);
                    }
                },
                actClose: {
                    caption: "jres:32131042",
                    icon: "gi-window-close",
                    run: (ev, ctx) => {
                        $.content(ev.target).close();
                    }
                }
            }
        }

        setEditMode(editMode: boolean) {

        }

        createForm() {
            this.form.form.layoutDescriptor = "L2M2S1";
            this.MakeSection("jres:30027574")
            this.form.addRow(this.getCaption("jmeno_cer")).addField("gstaticfield", { name: "jmeno_cer" })
            this.form.addRow(this.getCaption("dat_od_cer")).addField("gstaticfield", {
                name: "dat_od_cer",
                modelValueTransform: {
                    apply: (fieldValue) => { return Gordic.Templates.Formatters.date(fieldValue) }
                }
            })
            this.form.addRow(this.getCaption("dat_do_cer")).addField("gstaticfield", {
                name: "dat_do_cer",
                modelValueTransform: {
                    apply: (fieldValue) => { return Gordic.Templates.Formatters.date(fieldValue) }
                }
            })
            this.form.addRow(this.getCaption("id_cer")).addField("gstaticfield", { name: "id_cer" })
            this.form.addRow(this.getCaption("otisk_cer")).addField("gstaticfield", { name: "otisk_cer" })
            this.form.addRow(this.getCaption("tel_cer")).addField("gstaticfield", { name: "tel_cer" })
            this.form.addRow(this.getCaption("email_cer")).addField("gstaticfield", { name: "email_cer" })
            this.form.addRow(this.getCaption("firma_cer")).addField("gstaticfield", { name: "firma_cer" })
            this.form.addRow(this.getCaption("ulice_cer")).addField("gstaticfield", { name: "ulice_cer" })
            this.form.addRow(this.getCaption("obec_cer")).addField("gstaticfield", { name: "obec_cer" })
            this.form.addRow(this.getCaption("adresa_cer")).addField("gstaticfield", { name: "adresa_cer" })
            this.form.addRow(this.getCaption("bio_cer")).addField("gstaticfield", { name: "bio_cer" })
            this.form.addRow(this.getCaption("typ_cer_txt")).addField("gstaticfield", { name: "bio_cer_txt" })
            this.form.addRow(this.getCaption("alg_h_cer")).addField("gstaticfield", { name: "alg_h_cer" })
            this.form.addRow(this.getCaption("utvar_cer")).addField("gstaticfield", { name: "utvar_cer" })
            this.form.addRow(this.getCaption("aktivita_cer_txt")).addField("gstaticfield", { name: "aktivita_cer_txt" })
            this.form.addSection("jres:33000575"); //RC 33000575 : Certifikační autorita certifikátu
            this.form.addRow(this.getCaption("jmeno_cau")).addField("gstaticfield", { name: "jmeno_cau" })
            this.form.addRow(this.getCaption("ixs_cau")).addField("gstaticfield", { name: "ixs_cau" })
            this.form.addRow(this.getCaption("otisk_cau")).addField("gstaticfield", { name: "otisk_cau" })
            this.form.addRow(this.getCaption("priz_akr_cau_txt")).addField("gstaticfield", { name: "priz_akr_cau_txt" })
            this.form.addRow(this.getCaption("adresa_cau")).addField("gstaticfield", { name: "adresa_cau" })
        }

        private nextAndPreviousActionSpecial(next: boolean) {
            if (this.gridRc) {
                var obj: any;
                if (next == true)
                    obj = this.gridRc.current().nextRow.data;
                else
                    obj = this.gridRc.current().prevRow.data;
                this.gridRc.move(next);
                this.cnt.close();
                $.content().navigate(["Gordic.Adm.WebControls.DetailAdmSystemovyCertifikat",
                    {
                        currentFilter: this.filterObj,
                        gridRc: this.gridRc,
                        data: obj,
                        dataListDescription: this.dataListDescription,
                    }
                ],
                    {
                        ID: "DetailAdmSystemovyCertifikat",
                        newRecord: false,
                    });
            }
        }

        private getCaption(name: string): string {
            var result = this.dataListDescription.list_fields?.find((obj) => obj.field_name == name)?.field_caption;
            return result != null && result != undefined ? result : "";
        }

        private downloadCertificate() {
            new GFile().download({ guid: this.data.ixs_cer, filename: "{0}.cer".format(this.data.jmeno_cer?.toString()) }, "Gordic.Adm.WebControls.CertifikatyDownloadDocuments");
        }

        private changeAktivitaCer() {
            var form = new Gordic.Forms.Form({ name: "formAktivitaCer" })
                .addRow("jres:30027519").addField("gstringbox", {
                    name: "ixs_cer",
                    disabled: true,
                })
                .addRow("jres:30027523").addField("gstringbox", {
                    name: "jmeno_cer",
                    disabled: true
                })
                .addRow("jres:32131030").addField("gselectbox", Gordic.Prefabs.Select.gincakt(), {
                    name: "aktivita",
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required",
                    dropdown: true,
                    model: "model.aktivita=value.aktivita"
                })

            this.cnt.dialogs.simpleForm("jres:33000579", form, { //RC 33000579 : Editace certifikátu
                ixs_cer: this.data.ixs_cer,
                jmeno_cer: this.data.jmeno_cer,
                aktivita: this.data.aktivita
            }, {
                width: 600,
                height: 350,
                commandBar: [
                    { action: this.cnt.actions.actClose },
                    { action: this.cnt.actions.actChangeAktivitaCertifikatSave, primary: true }
                ]
            })
        }

        private saveAktivitaCer(ev) {
            var cnt = $.content(ev.target);
            var dto = {};
            cnt.findForms("formAktivitaCer").findFields().gfield("model", "collect", dto);
            var saveDto: Gordic.AdmIsl.Interface.GAdmSystemovyCertifikatSaveDto = {
                ixs_cer: this.data.ixs_cer,
                ixs: this.data.ixs,
                lic: this.data.lic,
                por_zast: this.data.por_zast,
                ix: this.data.ix,
                poznamka: this.data.poznamka,
                dat_od: this.data.dat_od,
                dat_do: this.data.dat_do,
                aktivita: dto["aktivita"],
                dat_zmena: this.data.dat_zmena,
                zmenu_prov: this.data.zmenu_prov,
                ixb: this.data.ixb,
                dat_zadost: this.data.dat_zadost,
                dat_schval: this.data.dat_schval,
                dat_zam: this.data.dat_zam,
                zmenu_prov_zadost: this.data.zmenu_prov_zadost,
                zmenu_prov_schval: this.data.zmenu_prov_schval,
                zmenu_prov_zam: this.data.zmenu_prov_zam,
                dat_mpd2: this.data.dat_mpd2
            };
            this.cnt.isl.AdmSystemovyCertifikat.upsert({ data: saveDto }).getData().done((result) => {
                cnt.close();
                this.updateDataInGrid();
            })
        }

        private updateDataInGrid() {
            this.cnt.isl.AdmSystemovyCertifikat.list({
                filters: {
                    ixs_cer: this.data.ixs_cer,
                    ixs: this.data.ixs,
                    lic: this.data.lic,
                    por_zast: this.data.por_zast,
                }
            }).getData().done((obj) => {
                if (this.options.currentFilter["aktivita"]) {
                    var grid = (this.options.gridRc as any).gridInstance.element;
                    if (grid.length != 0) {
                        var gridView: Gordic.Data.View = grid.ggrid("getView");
                        if (Array.isArray(this.options.currentFilter["aktivita"])) {
                            if (obj[0].aktivita) {
                                if (this.options.currentFilter["aktivita"].findIndex(item => item == obj[0].aktivita) != -1)
                                    gridView.updateData(obj[0], "update")
                                else
                                    gridView.updateData(obj[0], "delete")
                            }
                        } else {
                            if (obj[0].aktivita == this.options.currentFilter["aktivita"])
                                gridView.updateData(obj[0], "update")
                            else
                                gridView.updateData(obj[0], "delete")
                        }
                        grid.ggrid("setData", gridView);
                        grid.ggrid("activeRow", obj[0]);
                    }
                }
                this.cnt.close();
                $.content().navigate(["Gordic.Adm.WebControls.DetailAdmSystemovyCertifikat", {
                    currentFilter: this.options.currentFilter,
                    gridRc: this.gridRc,
                    data: obj[0],
                    dataListDescription: this.dataListDescription,
                }], {
                    ID: "DetailAdmSystemovyCertifikat",
                    newRecord: false,
                })
            })
        }
    }
}